import {
    RequestResultsStatus,
    SupportRequestChallengeProps,
    SupportRequestResultsModalTableRow,
    SupportRequestResultsResponse,
} from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import {
    AskForReviewFormSectionValue,
    EAskFowReviewFormSectionType,
} from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/components/ask-for-review/types';
import { SupportRequestAddressType } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/file-based-request-property/file-fields-mapping-config';
import { NotMyPropertyFormValues } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/components/ask-for-review/steps/not-my-property';

export const resetChallengeData: SupportRequestChallengeProps = {
    challenge_type: undefined,
    challenge_status_override: undefined,

    // 1. not my property
    challenge_selected_alt: undefined,
    challenge_googlemap_link: undefined,

    // 3. update property name and address
    challenge_property_name: undefined,
    challenge_property_address: undefined,

    // 4. nearby & sensitive location
    challenge_note: undefined,
};

export const challengeKeys = Object.keys(
    resetChallengeData,
) as (keyof SupportRequestChallengeProps)[];

export const basePropertyDataForChallenge: Partial<SupportRequestResultsResponse> = {
    entity_id: undefined,
    entity_name: undefined,
    entity_type: undefined,
    entity_address: undefined,
    report_type: undefined,
    closing_date: undefined,
    flag_reasons: undefined,
    field_error_code: undefined,
};

export const getChallengeStatus = (
    type: EAskFowReviewFormSectionType,
    data: AskForReviewFormSectionValue,
): RequestResultsStatus | undefined => {
    if (
        [
            EAskFowReviewFormSectionType.UpdatePropertyName,
            EAskFowReviewFormSectionType.UpdatePropertyAddress,
        ].includes(type) ||
        (type === EAskFowReviewFormSectionType.NotMyProperty && !data.isDirty) ||
        (type === EAskFowReviewFormSectionType.ReasonForNearby && data.isDirty)
    ) {
        return 'ReviewRequired';
    }

    return undefined;
};

export const getChallengeAddressData = (
    addressType: SupportRequestAddressType,
    data: NotMyPropertyFormValues,
): Partial<Omit<SupportRequestResultsModalTableRow, 'actions'>> => {
    if (addressType === 'lat_lng') {
        return {
            lat: data.lat,
            lng: data.lng,
        };
    }

    if (addressType === 'separate_columns') {
        return {
            city: data.city,
            street: data.street,
            state: data.state,
        };
    }

    return {
        formatted_address: data.formatted_address,
    };
};
